import {BaseClient} from '../utils/base-client';
import {CustomEventDefinition} from '../../../types/reports/custom-events';

class CustomEventsClient extends BaseClient<CustomEventDefinition[]> {
  buildEndpoint({projectID, workspaceId}) {
    if (workspaceId) {
      return `api/app/workspaces/${workspaceId}/custom_events/`;
    }
    return `api/app/custom_events/${projectID}/`;
  }

  processResponse(response) {
    return response.custom_events.map((customEvent) => ({...customEvent, custom: true}));
  }
}

export default new CustomEventsClient();
